import Language from "components/language";


const normalizeSlug = (value) => String(value || '').trim().toLowerCase();

const getLanguage = (value, languageMap = {}) => {
    const slug = normalizeSlug(value);

    return Language.Helpers.Options.getLanguage(slug, languageMap);
};

const getUnknownLanguageLabel = (value) => {
    const slug = normalizeSlug(value);

    return slug ? `Unknown language (${ slug.toUpperCase() })` : null;
};

const getLanguageLabel = (value, languageMap = {}) => {
    const language = getLanguage(value, languageMap);

    return language?.label || getUnknownLanguageLabel(value);
};

const TranslationAiLanguageHelper = {
    getLanguage,
    getLanguageLabel,
    getUnknownLanguageLabel,
};

export default TranslationAiLanguageHelper;
